module.exports = __webpack_public_path__ + "img/Icon-Value-Indicator.92d5fd34.svg";